export class LeaseInPlaceStatus{
    hmy:number;
    curRes3MonthORMore?:number;
    landlordAcceptVoucher?:number;
    landlordSignANew1Year?:number;
}